import { render } from "./SystemApproval.vue?vue&type=template&id=a6751a66&scoped=true"
import script from "./SystemApproval.vue?vue&type=script&lang=js"
export * from "./SystemApproval.vue?vue&type=script&lang=js"

import "./SystemApproval.vue?vue&type=style&index=0&id=a6751a66&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6751a66"]])

export default __exports__